const toDate = (str: string, isEnd = false) => {
  const [
    d,
    m,
    y,
    h = isEnd ? 23 : 0,
    min = isEnd ? 59 : 0,
    s = isEnd ? 59 : 0,
  ]: Array<any> = str.split(/[- :]/);
  return new Date(y, m - 1, d, h, min, s);
};

export const isDateBetween = (
  dateStr: string,
  startStr: string,
  endStr: string
) => {
  if (endStr === "") {
    const date = toDate(dateStr);
    const start = toDate(startStr);
    return (
      date.getFullYear() === start.getFullYear() &&
      date.getMonth() === start.getMonth() &&
      date.getDate() === start.getDate()
    );
  } else {
    const date = toDate(dateStr);
    return date >= toDate(startStr) && date <= toDate(endStr, true);
  }
};
